import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';

import withLocalization from '~/hoc/withLocalization';
import agent from '~/library/agent';
import Button from '../../../components/CustomButton/CustomButton.jsx';
import LoadingSpinner from '../../../elements/LoadingSpinner';

import '../../../styles/css/styles.css';
import '../../../styles/scss/visitor.scss';

class VisitorEntryPoint extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enc: null,
            qrDataUrl: null,
            loading: true,
            copied: false,
        };
    }

    componentDidMount() {
        this.fetchRegisterLink();
    }

    async fetchRegisterLink() {
        try {
            const data = await agent.visitors.getRegisterLink();
            this.setState({ enc: data.enc, qrDataUrl: data.qrDataUrl, loading: false });
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    getRegistrationUrl = () => {
        const { enc } = this.state;
        if (!enc) return '';
        return `${window.location.origin}/visitorRegister/${enc}`;
    };

    handleCopy = () => {
        const url = this.getRegistrationUrl();
        if (!url) return;
        navigator.clipboard.writeText(url).then(() => {
            this.setState({ copied: true });
            setTimeout(() => this.setState({ copied: false }), 2500);
        });
    };

    handleOpen = () => {
        const url = this.getRegistrationUrl();
        if (url) window.open(url, '_blank');
    };

    render() {
        const { t } = this.props;
        const { enc, qrDataUrl, loading, copied } = this.state;
        const url = this.getRegistrationUrl();

        return (
            <div className="table-list">
                <div className="d-flex mb-3">
                    <div className="d-md-flex align-items-center mb-md-0 mb-3">
                        <span className="fw-600 custom-customer-header text-capitalize ps-1 pe-1">{t('Entry Point')}</span>
                    </div>
                </div>

                {loading ? (
                    <LoadingSpinner />
                ) : !enc ? (
                    <div className="text-center text-danger py-4">
                        {t('Could not generate registration link. Please try again.')}
                    </div>
                ) : (
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10} md={7} lg={5}>

                            {/* QR Code Card */}
                            <div className="card mb-4">
                                <div className="card-body text-center">
                                    <p className="font-weight-bold mb-3">{t('Scan QR code')}</p>
                                    <div className="d-inline-flex p-3 border rounded mb-3">
                                        {qrDataUrl && <img src={qrDataUrl} alt="QR Code" width={180} height={180} />}
                                    </div>
                                    <p className="text-muted mb-0 vep-hint-text">
                                        {t('Point your camera at the QR code to open the visitor registration form.')}
                                    </p>
                                </div>
                            </div>

                            {/* OR divider */}
                            <div className="d-flex align-items-center mb-4">
                                <hr className="flex-grow-1 m-0" />
                                <span className="text-muted px-3 vep-or-divider">OR</span>
                                <hr className="flex-grow-1 m-0" />
                            </div>

                            {/* Registration Link */}
                            <div className="mb-3">
                                <label className="control-label fs15 mb-2">{t('Registration Link')}</label>
                                <div className="d-flex">
                                    <div
                                        className="form-control text-muted mr-2 vep-link-display"
                                    >
                                        {url}
                                    </div>
                                    <Button fill onClick={this.handleCopy} className="btn-wd flex-shrink-0">
                                        {copied ? `✓ ${t('Copied')}` : t('Copy Link')}
                                    </Button>
                                </div>
                            </div>

                            {/* Open button */}
                            <Button fill wd onClick={this.handleOpen} className="w-100">
                                {t('Click Here to Register')}
                            </Button>

                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

export default inject('commonStore')(
    withLocalization(observer(VisitorEntryPoint))
);
